import { render } from "./ShoppingListItemContent.vue?vue&type=template&id=7993e1e6&scoped=true"
import script from "./ShoppingListItemContent.vue?vue&type=script&lang=js"
export * from "./ShoppingListItemContent.vue?vue&type=script&lang=js"

import "./ShoppingListItemContent.vue?vue&type=style&index=0&id=7993e1e6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7993e1e6"]])

export default __exports__